import './styles/App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { SpeedInsights } from '@vercel/speed-insights/react';
import { Analytics } from '@vercel/analytics/react';
import Home from "./pages/Home";
import Quote from "./pages/Quote";
//import Navbar from './components/Navbar';
import Service from './pages/Service';
import NotFound from './pages/NotFound';
import Query from './pages/Query';
import LoginAndReg from './pages/autharization/LoginAndReg';
import ProtectedRoute from './components/Authantication/ProtectedRoute';
import ForgotPassword from './pages/autharization/Login/ForgotPassword';
import DashboardApp from './components/DashboardSection/DashboardContent/DashboardApp';
import DashboardQuotes from './components/DashboardSection/DashboardContent/DashboardQuotes';
import DashboardSettings from './components/DashboardSection/DashboardContent/DashboardSettings';
import DashboardUsers from './components/DashboardSection/DashboardContent/DashboardUsers';
import Dashboard from './pages/autharization/Dashboard';
import DashboardHome from './components/DashboardSection/DashboardContent/DashboardHome';
import Events from './pages/Events';
import WebinarDetail from './pages/WebinarDetail';
import WebinarRegistered from './pages/WebinarRegistered';
import WebinarPrivacy from './pages/WebinarPrivacy';
import WebinarAdmin from './pages/WebinarAdmin';
import News from './pages/News';
import NewsArticle from './pages/NewsArticle';
import ScrollManager from './components/ScrollManager';
import RevealManager from './components/RevealManager';

function App() {
  return (
    <Router>
      {/*<Navbar />*/}       {/* add it here, outside Routes */}
      <ScrollManager />
      <RevealManager />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/quote" element={<Quote />} />
        <Route path="/query" element={<Query />} />
        <Route path="/service" element={<Service />} />
        <Route path="/events" element={<Events />} />
        {/* A fixed page, so no webinar can use "privacy" as its web address */}
        <Route path="/events/privacy" element={<WebinarPrivacy />} />
        <Route path="/events/:slug" element={<WebinarDetail />} />
        <Route path="/events/:slug/registered" element={<WebinarRegistered />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/:slug" element={<NewsArticle />} />
        {/* Prototype: no sign-in, browser-only data. Production (Supabase): administrator sign-in, enforced by the database */}
        <Route path="/admin" element={<WebinarAdmin />} />
        {/* The Client Admin button's address: signed-in administrators go straight on to /admin */}
        <Route path="/admin/login" element={<WebinarAdmin page="login" />} />
        <Route path="/login" element={<LoginAndReg />} />
        <Route path="/register" element={<LoginAndReg />} />
        <Route path="/dashboard"
            element={
              <ProtectedRoute>
                { <Dashboard />}
              </ProtectedRoute>
            }
          >
            <Route path="Home" element={<DashboardHome />} />
            <Route path="Applications" element={<DashboardApp />} />
            <Route path="Users" element={<DashboardUsers />} />
            <Route path="Quotes" element={<DashboardQuotes />} />
            <Route path="Settings" element={<DashboardSettings />} />
        </Route>
        
        <Route path="/forgot-password"  element={<ForgotPassword />} />

        {/* Catch all unmatched routes */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <SpeedInsights />
      <Analytics />
    </Router>
  );
}

export default App;
